import React from "react";
import { Modal, Button } from "antd";
import { VERSION_CONFLICT_MESSAGE } from "../../utils/versionConflict";

/**
 * Blocking dialog for optimistic-concurrency (VersionConflict) errors.
 * Primary: Refresh — caller reloads Get-by-id and replaces form state.
 * Secondary: Cancel — leave without saving.
 */
const VersionConflictModal = ({
    open,
    message = VERSION_CONFLICT_MESSAGE,
    onRefresh,
    onCancel,
    refreshing = false,
}) => {
    return (
        <Modal
            open={open}
            title={<span className="font-custom">تداخل نسخه</span>}
            closable={false}
            maskClosable={false}
            keyboard={false}
            centered
            destroyOnClose
            footer={[
                <Button
                    key="cancel"
                    className="font-custom"
                    onClick={onCancel}
                    disabled={refreshing}
                >
                    انصراف
                </Button>,
                <Button
                    key="refresh"
                    type="primary"
                    className="font-custom"
                    loading={refreshing}
                    onClick={onRefresh}
                >
                    بازخوانی
                </Button>,
            ]}
        >
            <p dir="rtl" className="font-custom text-right m-0">
                {message || VERSION_CONFLICT_MESSAGE}
            </p>
        </Modal>
    );
};

export default VersionConflictModal;
